const lbCarHandlingModal = angular.module('app.lbCarHandlingModal', []);

lbCarHandlingModal.controller('lbCarHandlingModalCtrl', require('./lbCarHandlingModalCtrl'));
lbCarHandlingModal.component('lbCarHandlingModal', require('./lbCarHandlingModal'));

export default lbCarHandlingModal;


// WEBPACK FOOTER //
// ./src/components/lbCarHandlingModal/index.js